module.exports = __webpack_public_path__ + "img/tile-effects_jp.01fd88c.jpg";